/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import './styles.scss'
import { TypescriptComponent } from 'components/typescriptExample'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { Mdx, Link } from '@ta-interaktiv/contentbricks'
import { MDXProvider } from '@mdx-js/react'
import { AutofitIFrame } from '@ta-interaktiv/react-autofit-iframe'
import Toggle from 'react-toggle'
import { ArticleTeasers } from '@ta-interaktiv/react-article-teasers'

// TODO Set the correct article ID here
const ARTICLE_ID = '835706479183'

export function AppComponent() {
  const [showAbsolute, setShowPercentages] = React.useState(false)
  const isMobile = window.innerWidth < 600

  return (
    <MDXProvider
      components={{
        a: Link
      }}
    >
      <div className='index'>
        <Masthead articleId={ARTICLE_ID} />
        <ThemeSwitch />

        <header className='ui vertical very fitted segment'>
          <div className='ui container'>
            <Mdx
              className='ui header'
              file={require('text/bGwCb67YRyKp.mdx')}
            />
          </div>
        </header>

        <div className='ui vertical segment'>
          <div className='ui text container'>
            <div className='ta metainfo'>
              <div className='ta author'>
                Andreas Moor, Marc Brupbacher, Dominik Balmer, Titus Plattner
              </div>
              <div className='ta updated'>Aktualisiert am 18. Mai 2020</div>
            </div>
            <Mdx className='ta text' file={require('text/n96cAa_zD5hc.mdx')} />
          </div>
        </div>
        <div className='ui text container'>
          <AutofitIFrame src='//datawrapper.dwcdn.net/IJC8v' />
        </div>
        <div className='ui vertical segment'>
          <div className='ui text container'>
            <Mdx className='ta text' file={require('text/XzT1W9KjupwX.mdx')} />
          </div>
        </div>

        <div className='ui vertical very fitted segment'>
          <div className='ui text container chart'>
            <div className='bigToggleWrapper'>
              <div className='center'>
                <div className={'label ' + (!showAbsolute ? '' : 'off')}>
                  Relative Werte
                </div>
                <div className='toggleContainer'>
                  <Toggle
                    defaultChecked={showAbsolute}
                    icons={false}
                    onChange={e => {
                      setShowPercentages(e.target.checked)
                    }}
                  />
                </div>
                <div className={'label right ' + (showAbsolute ? '' : 'off')}>
                  Absolute Zahlen
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='ui text container'>
          <AutofitIFrame
            src={
              showAbsolute
                ? '//datawrapper.dwcdn.net/nkk4b'
                : '//datawrapper.dwcdn.net/NKdjY'
            }
          />
        </div>

        <div className='ui vertical segment'>
          <div className='ui text container'>
            <Mdx className='ta text' file={require('text/I_P0MLkox2ID.mdx')} />
          </div>
        </div>

        <Footer
          articleId={ARTICLE_ID}
          questions={[
            'Wie informativ war der Beitrag?',
            'Wie verständlich waren die Grafiken?'
          ]}
          credits={[
            ['Text', 'Marc Brupbacher, Dominik Balmer, Titus Plattner'],
            ['Konzept und Umsetzung', 'Marc Brupbacher, Andreas Moor']
          ]}
        />
        <div
          className='ui container'
          style={{ margin: isMobile ? '1.2em 0 3em' : '2em 0 3em' }}
        >
          <h4 className='teaser'>Weitere Beiträge zum Thema</h4>
          <ArticleTeasers
            numberOfCards='three'
            articleIds={['971503035355', '705468242240']}
          />
        </div>
      </div>
    </MDXProvider>
  )
}
